import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {rulesMap} from 'go/components/rules/rules';
import {UncheckOnChangeCheckbox as _UncheckOnChangeCheckbox} from 'app-ui-componentlibrary/dist/componentLibrary/form/UncheckOnChangeCheckbox';

export const UncheckOnChangeCheckbox = (props) => (
  <_UncheckOnChangeCheckbox {...props} {...{rulesMap}} />
);
export default connectDynamic(UncheckOnChangeCheckbox);
